import { ApiError, beablooApi } from '../../utils';

const setContactUs = () => {
  return async (dispatch, getState) => {
    const { general } = getState();

    const response = await beablooApi({
      method: 'GET',
      route: `/developments/${general.currentDevelopment.id}/pages/contact`,
    })
      .then((r) => r.data)
      .catch((e) => {
        throw new ApiError('failed to get contact', []);
      });

    dispatch({
      type: 'SET_CONTACT',
      data: response,
    });
  };
};

export { setContactUs };
